(function init() {
  angular.module('app').controller('host.views.debugTools.addHubGuaranteeLetterRequest.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.confirm = confirm;

      vm.hubGuaranteeLetterRequestId = '';
      vm.serviceRequestId = '';
      vm.guaranteeLetterUniqueId = '';

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        vm.saving += 1;

        const input = {
          hubGuaranteeLetterRequestId: vm.hubGuaranteeLetterRequestId,
          serviceRequestId: vm.serviceRequestId,
          guaranteeLetterUniqueId: vm.guaranteeLetterUniqueId,
        };

        debugToolSvc
          .addHubGuaranteeLetterRequest(input)
          .success(() => {
            abp.notify.info('Added inputted fields to Hub Guarantee Letter Request');
          })
          .finally(() => {
            vm.saving -= 1;
            vm.hubGuaranteeLetterRequestId = '';
            vm.serviceRequestId = '';
            vm.guaranteeLetterUniqueId = '';
          });
      }
    },
  ]);
})();
